/**
 * VYORA SaaS Centralized Motion Design Tokens
 * Restrained, fast, and enterprise-grade UI motion.
 */

export const MOTION_DURATIONS = {
  instant: 0.12, // 120ms - hover, tap, checkbox, toggle
  fast: 0.18,    // 180ms - dropdowns, tooltips, tabs
  normal: 0.24,  // 240ms - dialogs, toasts, cards
  moderate: 0.32,// 320ms - sidebars, drawers, complex expands
  storytelling: 0.48, // 480ms - charts, empty state entries
  float: 6.0,    // 6000ms - continuous float (subtle)
};

export const MOTION_EASINGS = {
  // Linear-grade sleek ease
  vyora: [0.22, 1, 0.36, 1] as const,
  // Standard ease-out
  easeOut: [0, 0, 0.2, 1] as const,
  // Standard ease-in-out
  easeInOut: [0.4, 0, 0.2, 1] as const,
  // Sharp exit
  easeIn: [0.4, 0, 1, 1] as const,
};

export const MOTION_SPRINGS = {
  snappy: {
    type: 'spring' as const,
    stiffness: 400,
    damping: 32,
    mass: 0.8,
  },
  gentle: {
    type: 'spring' as const,
    stiffness: 240,
    damping: 26,
    mass: 1,
  },
  bouncy: {
    type: 'spring' as const,
    stiffness: 300,
    damping: 20,
  },
};

export const MOTION_OFFSETS = {
  subtle: 4,
  sm: 8,
  md: 12,
  lg: 20,
  xl: 32,
};
